// extracted by mini-css-extract-plugin
module.exports = {"upgrade":"upgrade--mVR6U"};